import React from "react";
import { useNavigate } from "react-router-dom";
import { Wrench } from "lucide-react";
import { Panel, money } from "./singleUtils";

const STATE_TONE = {
  available: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  on_job: "bg-indigo-500/10 text-indigo-600 dark:text-indigo-400",
  inactive: "bg-slate-500/10 text-slate-500",
};
const STATE_LABEL = { available: "Available", on_job: "On Job", inactive: "Off Duty" };

const TechBoard = ({ technicians, financialAccess }) => {
  const navigate = useNavigate();
  const t = technicians || {};
  const s = t.summary || {};
  const list = t.list || [];
  return (
    <Panel title="Technicians" icon={Wrench} testid="tech-board"
      right={<button onClick={() => navigate("/dashboard/technicians")} className="text-[11px] font-semibold text-amber-600 dark:text-amber-400 hover:underline">Manage →</button>}>
      <div className="flex gap-1.5 mb-2.5" data-testid="tech-availability">
        <span className="text-[10px] font-bold font-mono px-2 py-1 rounded-sm bg-emerald-500/10 text-emerald-600 dark:text-emerald-400" data-testid="tech-status-badge-available">{s.available ?? 0} Available</span>
        <span className="text-[10px] font-bold font-mono px-2 py-1 rounded-sm bg-indigo-500/10 text-indigo-600 dark:text-indigo-400" data-testid="tech-status-badge-on-job">{s.on_job ?? 0} On Job</span>
        <span className="text-[10px] font-bold font-mono px-2 py-1 rounded-sm bg-slate-500/10 text-slate-500" data-testid="tech-status-badge-off-duty">{s.inactive ?? 0} Off Duty</span>
      </div>
      {list.length === 0 ? (
        <p className="text-[11px] text-muted-foreground py-2 text-center" data-testid="tech-empty">No technicians yet</p>
      ) : (
        <div className="divide-y divide-border/40">
          {list.slice(0, 6).map((r) => (
            <div key={r.technician_id} className="flex items-center justify-between gap-2 py-1.5" data-testid={`tech-row-${r.technician_id}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-1.5">
                  <p className="text-xs font-medium text-foreground truncate">{r.name}</p>
                  <span className={`text-[9px] font-semibold uppercase px-1 py-px rounded-sm ${STATE_TONE[r.state] || STATE_TONE.inactive}`}>{STATE_LABEL[r.state] || r.state}</span>
                </div>
                <p className="text-[10px] text-muted-foreground font-mono">
                  {r.jobs_today} today · {r.completed} done
                </p>
              </div>
              {financialAccess && (
                <div className="text-right shrink-0">
                  <p className="text-[11px] font-bold font-mono text-foreground">{money(r.revenue)}</p>
                  <p className="text-[10px] font-mono text-violet-600 dark:text-violet-400">{money(r.commission)} earned</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};

export default TechBoard;
